import { action, createRequestTypes } from '../base';

export const labelGenerationActionTypes = {
  UPDATE_LABEL_GENERATION: createRequestTypes('UPDATE_LABEL_GENERATION'),
  GET_LABEL_GENERATION: createRequestTypes('GET_LABEL_GENERATION'),
  GET_GLOBAL_LABELS: createRequestTypes('GET_GLOBAL_LABELS'),
  CREATE_LABEL: createRequestTypes('CREATE_LABEL'),
  DELETE_LABEL: createRequestTypes('DELETE_LABEL'),
};

class LabelGenerationActions {
  updateLabelGeneration = (payload, callback) => action(labelGenerationActionTypes.UPDATE_LABEL_GENERATION.REQUEST, {
    payload,
    callback,
  });

  updateLabelGenerationLoading = (updateLabelGenerationLoading) => action(labelGenerationActionTypes.UPDATE_LABEL_GENERATION.LOADING, {
    updateLabelGenerationLoading,
  })

  getLabelGeneration = (payload, callback) => action(labelGenerationActionTypes.GET_LABEL_GENERATION.REQUEST, {
    payload, callback,
  })

  getLabelGenerationLoading = (getLabelGenerationLoading) => action(labelGenerationActionTypes.GET_LABEL_GENERATION.LOADING, {
    getLabelGenerationLoading,
  })

  getLabelGenerationSuccess = (labelGeneration) => action(labelGenerationActionTypes.GET_LABEL_GENERATION.SUCCESS, {
    labelGeneration,
  })

  getGlobalLabels = (payload, callback) => action(labelGenerationActionTypes.GET_GLOBAL_LABELS.REQUEST, {
    payload, callback,
  })

  getGlobalLabelsLoading = (getGlobalLabelsLoading) => action(labelGenerationActionTypes.GET_GLOBAL_LABELS.LOADING, {
    getGlobalLabelsLoading,
  })

  getGlobalLabelsSuccess = (globalLabels) => action(labelGenerationActionTypes.GET_GLOBAL_LABELS.SUCCESS, {
    globalLabels,
  })

  createLabel = (payload, callback) => action(labelGenerationActionTypes.CREATE_LABEL.REQUEST, {
    payload, callback,
  })

  createLabelLoading = (createLabelLoading) => action(labelGenerationActionTypes.CREATE_LABEL.LOADING, {
    createLabelLoading,
  })

  deleteLabel = (payload, callback) => action(labelGenerationActionTypes.DELETE_LABEL.REQUEST, {
    payload, callback,
  })

  deleteLabelLoading = (deleteLabelLoading) => action(labelGenerationActionTypes.DELETE_LABEL.LOADING, {
    deleteLabelLoading,
  })
}

export default new LabelGenerationActions();
